
import _ from 'lodash';
export default function (restoreData, type, data,searchValue) { 
   if(type!=='reverse' && type!=='search'){
       data = _.sortBy(data, [function(o) { 
           try{
               return o[type].toLowerCase();
            }catch(e){
                return o[type];                
          }
         }]);

   }else if(type=='search'){
      data =  data.filter((element)=>{     
      let dummyElement = _.valuesIn(element);
      dummyElement = dummyElement.toString().toLowerCase().replace(',','');  
      searchValue = searchValue.toLowerCase();
      if(dummyElement.includes(searchValue) === true){
          return element;         
      }
    })
}else if(type==='reverse'){
   data= _.reverse(data);
   }
      restoreData(data);
} 
